// Web-only entry point.
//
// On web there is no upstream `expo-sqlite` runtime: every SQLite connection is a
// `@tursodatabase/sync-wasm` `Database` adapted to the expo-sqlite surface (see
// `lib/database/engine`). What remains here is the CHANGE-FEED layer, which is
// engine-agnostic and shared with native — it is what turns writes into the
// deterministic table-level feed the query layer invalidates from.
export { addDatabaseChangeListener } from "./add-database-change-listener.web.ts";
export type { AnySQLiteDatabase } from "./any-sqlite-database.web.ts";
export {
  addManualDatabaseChangeListener,
  emitManualDatabaseChange,
  type ManualDatabaseChangeEvent,
} from "./manual-change-listener.ts";
export { addBufferedManualDatabaseChangeListener } from "./buffered-manual-change-feed.ts";
export { attachSqliteChangeFeed } from "./attach-sqlite-change-feed.ts";
// The change feed's own SQL sniffing, exported so callers outside this package
// can ask the SAME question it does ("does this statement mutate, and what?")
// without re-deriving the regex. Used by the multi-tab leader proxy's
// lost-write marker to classify a rejected call as mutating or not.
export { extractMutatedTable, splitSqlStatements } from "./extract-mutated-table.ts";
export {
  bumpTableWriteClock,
  getTableWriteClock,
  hasTableWriteClockAdvanced,
  readTableWriteClockSnapshot,
} from "./table-write-clock.ts";
